import getUpdatedFilterArray from './getUpdatedFilterArray'

export default getUpdatedFilterArray
